/* Päikesevari üle pildi (editorial-split, valikuline seade `sun_sweep`).
 *
 * Muster on sama mis mujal saidil: JS ainult MÕÕDAB ja avaldab CSS-muutuja,
 * kogu kujundus on CSS-is. Ilma JS-ita jääb --sun-progress määramata ja
 * CSS-i vaikeväärtus hoiab laigu kaadrist väljas ehk pilt on lihtsalt pilt.
 *
 * Mõõdetakse ainult VERTIKAALSET positsiooni vaateaknas (ei tuletata ühtegi
 * kõrgust elemendi enda kõrgusest), seega ResizeObserveri tagasisidesilmust
 * siin tekkida ei saa.
 */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var elements = [];
  var ticking = false;

  function update() {
    ticking = false;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    for (var i = 0; i < elements.length; i++) {
      var el = elements[i];
      var rect = el.getBoundingClientRect();
      /* Vaatest väljas — ära kirjuta midagi. Odav väljapääs; elemente on
         lehel üksikud, seega eraldi IntersectionObserverit ei ole vaja
         (ja ta osutus ebausaldusväärseks, kui vaateaken tekib alles
         pärast skripti käivitumist). */
      if (rect.bottom < -vh * 0.2 || rect.top > vh * 1.2) continue;
      var p = (vh - rect.top) / (vh + rect.height);
      el.style.setProperty('--sun-progress', Math.min(1, Math.max(0, p)).toFixed(4));
    }
  }

  function request() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  function init() {
    var nodes = document.querySelectorAll('[data-sun-sweep]');
    if (!nodes.length) return;

    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].dataset.sunBound) continue;
      nodes[i].dataset.sunBound = '1';
      elements.push(nodes[i]);
    }

    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request, { passive: true });
    request();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
